import { RootState } from "../Store";

export const SELECT_REFUSE_MODAL = (state: RootState) =>
  state.modalStatesSlice.isRefuseModalOpen;
